export interface LdsMemoryCache<T> {
  has: () => boolean;
  get: () => T | null;
  set: (value: T) => T;
  update: (updater: (current: T | null) => T | null) => T | null;
  clear: () => void;
}

export const createLdsMemoryCache = <T>(initialValue: T | null = null): LdsMemoryCache<T> => {
  let value = initialValue;

  return {
    has: () => value !== null,
    get: () => value,
    set: (nextValue) => {
      value = nextValue;
      return value;
    },
    update: (updater) => {
      value = updater(value);
      return value;
    },
    clear: () => {
      value = null;
    },
  };
};

export const createLdsRequestCache = <T>() => {
  let request: Promise<T> | null = null;

  return (loader: () => Promise<T>) => {
    if (request) return request;

    request = loader().finally(() => {
      request = null;
    });

    return request;
  };
};
